import { useEffect, useState } from "react";
import { apiurl } from "../config/config.js";
import { CheckCircle } from "lucide-react";
import { motion } from "framer-motion";
import Layout, { Container } from "../components/layout.js";
import { useParams } from "react-router-dom";

export default function TrackShipment() {
let {awb} = useParams();
//   const [awb, setAwb] = useState("");
  const [shipment, setShipment] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchShipment();
  }, [awb]);

  const fetchShipment = async () => {
    if (!awb) return;
    setLoading(true);
    setError(null);
    try {
      const res = await fetch(
        `${apiurl}/api/order/shiprocket/shipments/${awb}`
      );
      const json = await res.json();
      if (json.success === false || !json.data) {
        setError("Tracking info not found. Please check the AWB number.");
        setShipment(null);
      } else {
        setShipment(json.data);
      }
    } catch (e) {
      console.error(e);
      setError("Something went wrong. Please try again later.");
      setShipment(null);
    }
    setLoading(false);
  };

  return (
    <Layout>
      <Container overflow={"overflow-scroll"}>
        <div className="min-h-screen bg-gray-50 py-10 px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-6 text-center">
              📦 Track Your Shipment
            </h2>

            {/* <div className="flex gap-3 mb-6">
              <input
                type="text"
                value={awb}
                onChange={(e) => setAwb(e.target.value)}
                placeholder="Enter AWB Number"
                className="flex-1 border border-gray-300 rounded-lg px-4 py-2 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
              <button
                onClick={fetchShipment}
                className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                {loading ? "Loading..." : "Track"}
              </button>
            </div> */}

            {error && (
              <div className="bg-red-100 text-red-600 p-3 rounded mb-4">
                {error}
              </div>
            )}

            {shipment && (
              <div className="bg-white shadow-md rounded-lg p-6">
                <h3 className="text-xl font-semibold mb-4">
                  Current Status:{" "}
                  <span className="text-blue-600">
                    {shipment.current_status}
                  </span>
                </h3>

                <div className="border-l-4 border-blue-600 pl-4 space-y-4">
                  {shipment.scans?.length > 0 ? (
                    shipment.scans.map((scan, i) => (
                      <StatusStep
                        key={i}
                        status={scan.status}
                        label={scan["sr-status-label"] || scan.status}
                        location={scan.location}
                        date={scan.date}
                      />
                    ))
                  ) : (
                    <p className="text-gray-500 text-sm">
                      No tracking events available.
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Container>
    </Layout>
  );
}

const StatusStep = ({ label, location, date }) => {
  return (
    <motion.div
      className="flex gap-4 items-start relative pl-6"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div className="absolute left-0 top-1">
        <CheckCircle className="text-green-500" size={20} />
      </div>
      <div>
        <p className="font-medium">{label}</p>
        {location && <p className="text-sm text-gray-500">{location}</p>}
        <p className="text-xs text-gray-400">{date}</p>
      </div>
    </motion.div>
  );
};
